import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import type { ModuleType } from 'i18next';

// Language detection options
const languageDetector = {
  type: 'languageDetector' as ModuleType,
  async: true,
  init: () => { },
  detect: (callback: (lng: string) => void) => {
    // Check localStorage first
    const storedLanguage = localStorage.getItem('preferredLanguage');
    if (storedLanguage) {
      callback(storedLanguage);
      return;
    }

    // Fallback to browser language
    const browserLang = navigator.language.split('-')[0];
    if (['en', 'de'].includes(browserLang)) {
      callback(browserLang);
      return;
    }

    // Default to English
    callback('en');
  },
  cacheUserLanguage: (lng: string) => {
    localStorage.setItem('preferredLanguage', lng);
    // Update HTML lang attribute
    document.documentElement.lang = lng;
  }
};

i18n
  .use(Backend)
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'de'],
    ns: ['common', 'servicesLegacyRescue'],
    defaultNS: 'common',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

// Update HTML lang attribute when language changes
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n; 